(function () {
'use strict';

class hyTableauUtils {
  constructor(scope, timeout) {
    this.scope = scope;
    this.timeout = timeout;

    this.timed = f => this.timeout(f, 200);

    this.filterCmp = (dataValue, filterValue) =>
      dataValue != null && dataValue.toString().toLowerCase().includes(filterValue.toLowerCase());
    
    this.getX = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);

    this.castProperty = (obj, propertyName, join) => obj instanceof Array
          ? (join ? obj.map(x => x[propertyName]).join() : obj.map(x => x[propertyName]))
          : obj[propertyName];

    this.reductor = (acc, el) => { acc[el[this.scope.idProperty]] = true; return acc; };

    this.scope.getX = this.getX;
    this.scope.timed = this.timed;
  }
};

window.tableau = window.tableau || {};
window.tableau.Utils = hyTableauUtils;
})();